const { each } = require("jquery");

import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import interactionPlugin, { Draggable } from '@fullcalendar/interaction';
import moment from 'moment';
require('moment-precise-range-plugin');

/* $(document).on('turbolinks:load', function () {
    resizeDiv();
});

window.onresize = function(event) {
resizeDiv();
}

function resizeDiv() {
    const vph = $(window).height();
    const nvh = $('.menu-w').height();
    const snvh = $('.sub-menu-w').height(); // sub menu height
    const nav = nvh + snvh;
    const fvh = $('.footer-w').height();
    const sm = 60; //sidebar margin
    const nmb = 42; //navbar margin bottom
    const height = vph - nvh - nmb;
    if (height > 100){
        $('.fullheight').css({'height': height + 'px'});
    }
    //$('.hs-sidebar').css({'max-height': vph - nav - sm + 'px'})
    $('.fullscroll').css({'height': vph + 'px'});
    $('.fullpage').css({'min-height': vph + 'px'});
    $('.content-home').css({'min-height': vph - nvh - fvh + 'px'});
    console.log(height);
    console.log("window height:" + vph);
    console.log("nav height:" + nav);
    console.log("menu:" + snvh);
} */

$(document).on('turbolinks:load', function () {
    $('[data-toggle="offcanvas"]').on('click', function () {
        $('.offcanvas-collapse').toggleClass('open')
    })

    $('.navbar-nav>li>.nav-link').on('click', function(){
        $('.offcanvas-collapse').toggleClass('open')
    })
});

$(document).on('click', '[data-toggle="lightbox"]', function (event) {
    event.preventDefault();
    $(this).ekkoLightbox({
        alwaysShowClose: true
    });
});

$(document).on('click', '[data-behaviour="reload-on-click"]', function (event) {
    Turbolinks.visit(location.toString());
});

$(document).on('click', 'a.remove_fields', function (e) {
    let link = $(this);
    if (link.hasClass('remove_fields')) {
        if (!link || !e) return
        // Prevent the browser from following the URL.
        e.preventDefault()
        // Find the parent wrapper for the set of nested fields.
        let fieldParent = link.closest('.nested-fields')
        // If there is a parent wrapper, find the hidden delete field.
        let deleteField = fieldParent
            ? $(fieldParent).find('input[type="hidden"]')
            : null
        // If there is a delete field, update the value to `1` and hide the corresponding nested fields.
        if (deleteField) {
            $(deleteField).val(1);
            $(fieldParent).hide();
        }
    }
});

$(document).on('click', '[data-behaviour="appstorelink"]', function (event) {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        // some code..

        var anchor = this;
        event.preventDefault();
        var now = new Date().valueOf();
        setTimeout(function () {
            if (new Date().valueOf() - now > 100) return;
            window.location = $(anchor).attr('href');
        }, 50);
        window.location = $(this).data('applink');
    }
});

window.turbolinksReload = function () {
    Turbolinks.enableTransitionCache(true);
    Turbolinks.visit(location.toString());
    Turbolinks.enableTransitionCache(false);
}

$(document).on('turbolinks:load', function () {
    $('.select2').each(function (idx) {
        $(this).width();
    });
});


window.FontAwesomeConfig = { autoReplaceSvg: 'nest' }

$(document).on('turbolinks:load', function () {
    $('.sharing-list').each(function () {
        const $select = $(this);
        const $modal = $select.closest('.modal');
        const $container = $select.closest('.modal-body');
        const $controls = $container.find('.js-sharing-membership-controls');
        const $selectionCount = $controls.find('.js-sharing-selection-count');

        if (!$select.hasClass('select2-hidden-accessible')) {
            $select.select2({
                width: 'resolve',
                placeholder: $select.data('placeholder') || 'Select users to share with',
                dropdownParent: $modal.length ? $modal : $(document.body)
            });
        }

        if ($controls.length === 0) {
            return;
        }

        const updateSelectionCount = function () {
            const selectedCount = ($select.val() || []).length;
            $selectionCount.text(selectedCount);
        };

        updateSelectionCount();
        $select.off('change.membershipSharing').on('change.membershipSharing', updateSelectionCount);

        $controls.find('.js-select-shareable-memberships')
            .off('click.membershipSharing')
            .on('click.membershipSharing', function () {
                const selectableValues = $select.find('option:not(:disabled)').map(function () {
                    return $(this).val();
                }).get();
                $select.val(selectableValues).trigger('change');
            });

        $controls.find('.js-clear-shareable-memberships')
            .off('click.membershipSharing')
            .on('click.membershipSharing', function () {
                $select.val([]).trigger('change');
            });
    });
});


$(document).on('turbolinks:load', function () {
    $('input.timepicker').timepicker({
        minuteStep: 15,
        defaultTime: '',
        // secondStep: 5,
        showInputs: false,
        // template: 'modal',
        // modalBackdrop: true,
        showSeconds: false,
        showMeridian: false
    });
});

$(document).on('turbolinks:load', function () {
    $('.modal').appendTo("body");

    // Convert Bootstrap 5 data attributes to Bootstrap 4
    $('[data-bs-toggle="collapse"]').each(function() {
        $(this).attr('data-toggle', 'collapse').removeAttr('data-bs-toggle');
    });
    $('[data-bs-target]').each(function() {
        var target = $(this).attr('data-bs-target');
        $(this).attr('data-target', target).removeAttr('data-bs-target');
    });
    $('[data-bs-parent]').each(function() {
        var parent = $(this).attr('data-bs-parent');
        $(this).attr('data-parent', parent).removeAttr('data-bs-parent');
    });
    
    // Initialize collapse for Bootstrap 4
    $('[data-toggle="collapse"]').on('click', function(e) {
        e.preventDefault();
        var target = $(this).data('target');
        $(target).collapse('toggle');
    });

    // Scoped compatibility dropdowns for HR membership header actions/export.
    const membershipHeaderDropdownSelector = '#actionsDropdown, #exportDropdown';
    const closeMembershipHeaderDropdowns = function () {
        $(membershipHeaderDropdownSelector).each(function () {
            const dropdown = $(this).closest('.dropdown');
            dropdown.removeClass('show');
            dropdown.find('.dropdown-menu').first().removeClass('show');
            $(this).attr('aria-expanded', 'false');
        });
    };

    if ($(membershipHeaderDropdownSelector).length > 0) {
        $(document).off('click.hrMembershipDropdown');

        $(membershipHeaderDropdownSelector).off('click.hrMembershipDropdown').on('click.hrMembershipDropdown', function (e) {
            e.preventDefault();
            e.stopPropagation();

            const dropdown = $(this).closest('.dropdown');
            const menu = dropdown.find('.dropdown-menu').first();
            const shouldOpen = !dropdown.hasClass('show');

            closeMembershipHeaderDropdowns();
            if (shouldOpen) {
                dropdown.addClass('show');
                menu.addClass('show');
                $(this).attr('aria-expanded', 'true');
            }
        });

        $(document).on('click.hrMembershipDropdown', function (e) {
            const inMembershipHeaderDropdown = $(e.target).closest('.dropdown').find(membershipHeaderDropdownSelector).length > 0;
            if (!inMembershipHeaderDropdown) {
                closeMembershipHeaderDropdowns();
            }
        });
    }
});

$(document).on('turbolinks:load', function () {
    $('#addMember .select2').select2({
        dropdownParent: $("#addMember"),
    });
    $('.selector').select2();

    if ($('.dt-detailed-report').length) {

        $('.dt-detailed-report thead tr').clone(true).appendTo('.dt-detailed-report thead');
        $('.dt-detailed-report thead tr:eq(1) th').each(function (i) {
            var title = $(this).text();
            if (i == 5) {
                $(this).html('<select style="width: auto" class="form-control form-control-sm"><option value="all">All</option><option value="with_concern">Concern</option><option value="no_concern">No Concern</option></select>');
            } else if (i == 3) {
                $(this).html('<select style="width: auto" class="form-control form-control-sm"><option value="all">All</option><option value="today">Today</option><option value="since_yesterday">Since yesterday</option><option value="in_last_week">In last week</option><option value="in_last_month">In last month</option><option value="in_last_3_months">In last 3 months</option><option value="in_last_6_months">In last 6 months</option></select>');
            } else if (i == 4 || i == 6 || i == 7 || i == 8) {
                $(this).html('');
            } else {
                $(this).html('<input type="text" style="width: auto" class="form-control form-control-sm" placeholder="Filter by ' + title + '" />');
            }

            $('input', this).on('keyup change', function () {
                if (detailed_report_table.column(i).search() !== this.value) {
                    detailed_report_table
                        .column(i)
                        .search(this.value, true, false)
                        .draw();
                }
            });
            $('select', this).on('change', function () {
                if (detailed_report_table.column(i).search() !== this.value) {
                    detailed_report_table
                        .column(i)
                        .search(this.value, true, false)
                        .draw();
                }
            });
        });


        var detailed_report_table = $('.dt-detailed-report').DataTable({
            orderCellsTop: true,
            fixedHeader: true,
            bDestroy: true,
            order: [[3, 'desc']],
            columnDefs: [
                {
                    targets: [7],
                    visible: false,
                    searchable: false
                }
            ],
            stateSave: false,
            dom: 'Bfrtip',
            search: {
                "regex": true,
            },
            buttons: [
                {
                    extend: 'csv',
                    text: '<i class="picons-thin-icon-thin-0094_file_table"></i><span class="ml-2">Export CSV</span>',
                    className: 'btn btn-primary',
                    titleAttr: 'Export CSV',
                    exportOptions: {
                        columns: [0, 1, 2, 3, 4, 5, 6, 7]
                    }
                },
                {
                    extend: 'pdf',
                    text: '<i class="picons-thin-icon-thin-0077_document_file_pdf_adobe_acrobat"></i><span class="ml-2">Export PDF</span>',
                    className: 'btn btn-primary',
                    titleAttr: 'Export PDF',
                    title: "Reports " + (new Date()).toDateString(),
                    footer: true,
                    orientation: 'landscape',
                    exportOptions: {
                        columns: [0, 1, 2, 3, 4, 5, 6, 7]
                    },
                    customize: function (doc) {
                        // Splice the image in after the header, but before the table
                        // doc.defaultStyle.font = 'Arial';
                        // doc['header'] = (function (page, pages) {
                        //     return {
                        //         columns: [
                        //             { text: 'Safety Revolution', style: 'header' },
                        //             ''
                        //         ],
                        //         margin: [42, 20],
                        //     }

                        // });
                        doc['footer'] = (function (page, pages) {
                            return {
                                columns: [
                                    {
                                        alignment: 'left',
                                        text: [(new Date()).toDateString()]
                                    },
                                    {
                                        alignment: 'right',
                                        text: ['Page ', { text: page.toString() }, ' of ', { text: pages.toString() }]
                                    }
                                ],
                                margin: [42, 20],
                            }
                        });
                        doc.content[1].table.widths = ['20%', '10%', '10%', '10%',
                            '10%', '7%', '7%', '26%'];
                        var rowCount = doc.content[1].table.body.length;
                        for (var i = 1; i < rowCount; i++) {
                            doc.content[1].table.body[i][3].alignment = 'center';
                            doc.content[1].table.body[i][4].alignment = 'center';
                            doc.content[1].table.body[i][5].alignment = 'center';
                            doc.content[1].table.body[i][6].alignment = 'center';
                            doc.content[1].table.body[i][7].alignment = 'center';
                        }
                        doc.content.splice(0, 0, {
                            margin: [0, 0, 0, 0],
                            alignment: 'right',
                            width: 80,
                            image: 'data:image/png;base64,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'
                        });
                    },
                }
            ]
        });
        document.addEventListener("turbolinks:before-cache", function () {
            if (detailed_report_table !== null) {
                detailed_report_table.destroy();
                detailed_report_table = null;
            }
        });
    } else {
        $('.dt-detailed-report').hide();
    }

    var dt1 = $('.dt').DataTable({
        stateSave: true,
        bDestroy: true,
    });
    document.addEventListener("turbolinks:before-cache", function () {
        if (dt1 !== null) {
            dt1.destroy();
            dt1 = null;
        }
    });
    $('a[data-toggle="tab"]').on('shown.bs.tab', function () {
        $.fn.dataTable.tables({ visible: true, api: true }).columns.adjust();
    });

    function format(d) {
        // `d` is the original data object for the row
        return (
            '<table cellpadding="0" cellspacing="0" border="0" class="table table-sm table-striped table-child mb-0" width="100%">' +
            '<tr>' +
            '<td style="width: 150px">Accepted Reason:</td>' +
            '<td>' +
            d.leave_reason +
            '</td>' +
            '</tr>' +
            '<tr>' +
            '<td style="width: 150px">Decline Reason:</td>' +
            '<td>' +
            // not empty
            (d.decline_reason ? d.decline_reason : 'N/A') +
            '</td>' +
            '</tr>' +
            '<tr>' +
            '<td style="width: 150px">Notes:</td>' +
            '<td>' +
            d.notes +
            '</td>' +
            '</tr>' +
            '</table>'
        );
    }

    if ($('.employee-leave-dt').length > 0) {
        var employeeLeaveDt = $('.employee-leave-dt').DataTable({
            stateSave: false,
            bDestroy: true,
            data: window.employeeLeavesDataTable.employee_leaves,
            pageLength: 25,
            order: [],
            language: {
                search: "",
                searchPlaceholder: "Search...",
                lengthMenu: "Show _MENU_",
                zeroRecords: "No leave requests found",
                info: "Showing _START_ to _END_ of _TOTAL_ leave requests",
                infoEmpty: "No leave requests found",
                infoFiltered: "(filtered from _MAX_ total leave requests)",
            },
            columns: [
                {
                    className: 'dt-control',
                    orderable: false,
                    data: null,
                    defaultContent: '<i class="picons-thin-icon-thin-0151_plus_add_new"></i>',
                },
                {
                    data: 'type',
                    defaultContent: ""
                },
                {
                    data: {
                    _:    'start_date.display',
                    sort: 'start_date.timestamp'
                    },
                    defaultContent: ""
                },
                {
                    data: {
                    _:    'end_date.display',
                    sort: 'end_date.timestamp'
                    },
                    defaultContent: ""
                },
                {
                    data: 'status',
                    defaultContent: ""
                },
                {
                    data: {
                    _:    'created_date.display',
                    sort: 'created_date.timestamp'
                    },
                    defaultContent: ""
                },
            ],

            dom:
            "<'row'<'col-sm-12 col-md-6 d-flex align-items-center'l><'col-sm-12 col-md-6 d-flex align-items-center justify-content-end'<'filter-pane d-flex mr-2'>f>>" +
            "<'row'<'col-sm-12'tr>>" +
            "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
        });

        // Add event listener for opening and closing details
        $('#leave-list-dt tbody').on('click', 'td.dt-control', function () {
            var tr = $(this).closest('tr');
            var row = employeeLeaveDt.row(tr);


            if (row.child.isShown()) {
                // This row is already open - close it
                row.child.hide();
                tr.removeClass('shown');
                // add icon
                $(this).html('<i class="picons-thin-icon-thin-0151_plus_add_new"></i>');

            } else {
                // Open this row
                row.child(format(row.data())).show();
                tr.addClass('shown');
                // add icon
                $(this).html('<i class="picons-thin-icon-thin-0152_minus_delete_remove"></i>');
               // if shown find next row and add class
                tr.next().addClass('child-row');
            }
        });

        document.addEventListener("turbolinks:before-cache", function () {
            if (employeeLeaveDt !== null) {
            employeeLeaveDt.destroy();
            employeeLeaveDt = null;
            }
        });
    }

    var dtdocs = $('.dt-documents').DataTable({
        stateSave: true,
        bLengthChange: true,
        bPaginate: true,
        bFilter: true,
        bDestroy: true,
        columnDefs: [
            { orderable: false, targets: -1 }
        ],
        stateSaveParams: function (settings, data) {
            data.length = 25;
        },
        lengthMenu: [[10, 25, 50, -1], [10, 25, 50, "All"]],
        language: {
            emptyTable: "No files uploaded to folder"
        }
    });

    $("div.dt-heading.hs-documents").html('<h5>My Documents Requiring Review</h5>');
    $("div.dt-heading.staff-documents").html('<h5>My Wellbeing Files</h5>');
    document.addEventListener("turbolinks:before-cache", function () {
        if (dtdocs !== null) {
            dtdocs.destroy();
            dtdocs = null;
        }
    });

    var dt2 = $('.dt-simple').DataTable({
        stateSave: true,
        bPaginate: false,
        bLengthChange: false,
        bFilter: true,
        bInfo: true,
        bDestroy: true,
        bAutoWidth: false
    });
    document.addEventListener("turbolinks:before-cache", function () {
        if (dt2 !== null) {
            dt2.destroy();
            dt2 = null;
        }
    });

    var sortdir = $('.dt-sorted').data('sortorderdir');
    if (sortdir == undefined) { sortdir = 'asc'; }
    var dt3 = $('.dt-sorted-with-export').DataTable({
        order: [[$('.dt-sorted-with-export').data('sortordercol'), sortdir]],
        stateSave: true,
        dom: 'Bfrtip',
        buttons: [
            {
                extend: 'csv',
                text: 'Export CSV',
                className: 'btn btn-primary'
            }
        ]
    });
    document.addEventListener("turbolinks:before-cache", function () {
        if (dt3 !== null) {
            dt3.destroy();
            dt3 = null;
        }
    });

    if ($('.acceptedLeaveTable').length) {
        var leaveTable = $('.acceptedLeaveTable').DataTable({
            bDestroy: true,
            data: window.teamLeavesDataTable.acceptedEmployeeLeaves,
            columns: [
                {
                    data: 'name',
                    defaultContent: ""
                },
                {
                    data: 'type',
                    defaultContent: ""
                },
                {
                    data: {
                    _:    'start_date.display',
                    sort: 'start_date.timestamp'
                    },
                    defaultContent: ""
                },
                {
                    data: {
                    _:    'end_date.display',
                    sort: 'end_date.timestamp'
                    },
                    defaultContent: ""
                },
                {
                    data: 'days_count',
                    defaultContent: ""
                },
            ],
            language: {
                emptyTable: "No leave requests found",
                info: "Showing _START_ to _END_ of _TOTAL_ leave requests",
                infoEmpty: "Showing 0 to 0 of 0 leave requests",
                infoFiltered: "(filtered from _MAX_ total leave requests)",
                lengthMenu: "Show _MENU_ leave requests",
                search: "Search:",
                zeroRecords: "No matching leave requests found"
            }
        });

        document.addEventListener("turbolinks:before-cache", function () {
          if (leaveTable !== null) {
            leaveTable.destroy();
            leaveTable = null;
          }
        });
    }

    // Load only if the element exists
    if ($('.holidayAllowanceTable').length) {
        var staffAllowanceTable = $('.holidayAllowanceTable').DataTable({
            bDestroy: true,
            data: window.teamLeavesDataTable.holidayAllowance,
            columnDefs: [{
                defaultContent: "",
                targets: "_all"
            }],
            language: {
                emptyTable: "No staff members found",
                info: "Showing _START_ to _END_ of _TOTAL_ staff members",
                infoEmpty: "Showing 0 to 0 of 0 staff members",
                infoFiltered: "(filtered from _MAX_ total staff members)",
                lengthMenu: "Show _MENU_ staff",
                search: "Search:",
                zeroRecords: "No matching staff members found"
            }
        });
        var staffAllowanceButtons = new $.fn.dataTable.Buttons(staffAllowanceTable, {
            buttons: [
                {
                    extend: 'pdf',
                    text: 'Download PDF',
                    className: 'dropdown-item'
                },
                {
                    extend: 'csv',
                    text: 'Download CSV',
                    className: 'dropdown-item'
                }
        ]
        }).container().appendTo($('#staffAllowanceExport'));

        document.addEventListener("turbolinks:before-cache", function () {
            if (staffAllowanceTable !== null) {
                staffAllowanceTable.destroy();
                staffAllowanceTable = null;
            }
        });
    }

    // Enforce: leave end date cannot be before leave start date.
    // Some pages use ids like "hr/employee_leave_start_time", so we also match by suffix and by CSS classes.
    var leaveStartSelector = '#employee_leave_start_time, input[id$="employee_leave_start_time"], .start-date, .start_date';
    var leaveEndSelector = '#employee_leave_end_time, input[id$="employee_leave_end_time"], .end-date, .end_date';

    $(document).off('apply.daterangepicker.leaveConstraints', leaveStartSelector);
    $(document).off('apply.daterangepicker.leaveConstraints', leaveEndSelector);

    $(document).on('apply.daterangepicker.leaveConstraints', leaveStartSelector, function (ev, picker) {
        var $start = $(this);
        var $form = $start.closest('form');
        var $end = $form.length ? $form.find(leaveEndSelector).first() : $(leaveEndSelector).first();
        if (!$end.length) return;

        var endPicker = $end.data('daterangepicker');
        if (!endPicker || !endPicker.startDate) return;

        var startDate = picker.startDate;
        var endDate = endPicker.startDate;

        // Disallow selecting an end date before the start date
        endPicker.minDate = startDate.clone();

        // If current end is invalid, snap it forward
        if (endDate.isBefore(startDate, 'day')) {
            $end.val(startDate.format('DD/MM/YYYY'));
            endPicker.setStartDate(startDate);
            endPicker.setEndDate(startDate);
        }
    });

    $(document).on('apply.daterangepicker.leaveConstraints', leaveEndSelector, function (ev, picker) {
        var $end = $(this);
        var $form = $end.closest('form');
        var $start = $form.length ? $form.find(leaveStartSelector).first() : $(leaveStartSelector).first();
        if (!$start.length) return;

        var startPicker = $start.data('daterangepicker');
        if (!startPicker || !startPicker.startDate) return;

        var endDate = picker.startDate;

        // Disallow selecting a start date after the end date
        startPicker.maxDate = endDate.clone();

        // If current start is invalid, snap it back
        var startDate = startPicker.startDate;
        if (startDate.isAfter(endDate, 'day')) {
            $start.val(endDate.format('DD/MM/YYYY'));
            startPicker.setStartDate(endDate);
            startPicker.setEndDate(endDate);
        }
    });

    if ($(".genericHrDataTable").length) {
        var order = $(".genericHrDataTable").data("order") || [0, "asc"];
        var genericHrDataTable = $(".genericHrDataTable").DataTable({
            order: [order],
        });

        document.addEventListener("turbolinks:before-cache", function () {
            if (genericHrDataTable !== null) {
                genericHrDataTable.destroy();
                genericHrDataTable = null;
            }
        });
    }

    if ($(".HrSelect2").length) {
        $(".HrSelect2").each(function () {
            $(this).select2({
                placeholder: $(this).data("placeholder"),
                closeOnSelect: $(this).data("closeonselect") !== false,
                width: '100%'
            });
        });
    }

    if ($(".HrSingleDatePicker").length) {
        $(".HrSingleDatePicker").each(function () {
            $(this).daterangepicker({
                autoApply: true,
                showDropdowns: true,
                minYear: new Date().getFullYear() - 100,
                maxYear: new Date().getFullYear() + 5,
                singleDatePicker: true,
                autoUpdateInput: true,
                locale: {
                    cancelLabel: "Clear",
                    format: "DD/MM/YYYY",
                    firstDay: 1
                }
            });
        });
    }
});




$(document).on('turbolinks:load', function () {
    $('#scheduled_report_every').on('change', function () {
        if ($(this).val() == 'week') {
            $('.days-of-week-options').show();
        } else {
            $('.days-of-week-options').hide();
        }
        $('.every-label').text($(this).val() + 's')
    });

    $(document).find('input[data-behaviour~=repeatchbx]').unbind('click');
    $(document).find('input[data-behaviour~=repeatchbx]').on('click', function () {
        if ($('input[data-behaviour~=repeatchbx]').is(':checked')) {
            $('.repeat-options').show();
            $('.scheduled_at_date_row label').text('Starting On');
        } else {
            $('.repeat-options').hide();
            $('.scheduled_at_date_row label').text('Scheduled On');
        }
    });
});

$(document).on('turbolinks:load', function () {
    $('.todo-sidebar-section-sub-section-toggler').not('.disabled').on("click", function () {

        const link = $(this);
        const path = $(this).data('path');
        const sectionId = $(this).data('sectionid');
        var documentsContainer = $('#active-documents-' + sectionId);

        if (path && sectionId && documentsContainer && documentsContainer.children("li").length == 0) {
            link.closest('.todo-sidebar-section-sub-section').find('.todo-sidebar-section-sub-section-content').slideToggle(100);
            $.ajax({
                url: path,
                dataType: 'html',
                success: function(response) {
                    documentsContainer.html(response);
                },
                error: function(xhr, status, error) {
                    documentsContainer.html("Error loading documents");
                }
            });
        } else {
            // Sidebar Sub Sections foldable trigger
            $(this).closest('.todo-sidebar-section-sub-section').find('.todo-sidebar-section-sub-section-content').slideToggle(100);
        }

        $(this).find('i').toggleClass('os-icon-ui-22 os-icon-ui-23');
    });

    // open/highlight relevant bits of the side bar
    const current_section_id = window.hs_section_id;
    if (current_section_id) {
        let section_container = $('.todo-sidebar-section-sub-section[data-sectionid=' + current_section_id + ']');
        section_container.addClass('active');
        let toggler = section_container.find('.todo-sidebar-section-sub-section-toggler');
        section_container.find('.todo-sidebar-section-sub-section-toggler i').toggleClass('os-icon-ui-22 os-icon-ui-23');
        section_container.find('.section-icon i').toggleClass('picons-thin-icon-thin-0111_folder_files_documents picons-thin-icon-thin-0110_folder');
        section_container.find('.todo-sidebar-section-sub-section-content').show();

        var path = toggler.data('path');
        var documentsContainer = $('#active-documents-' + current_section_id);

        if (path && documentsContainer) {
            $.ajax({
                url: path,
                dataType: 'html',
                success: function(response) {
                  documentsContainer.html(response);
                },
                error: function(xhr, status, error) {
                    documentsContainer.html("Error loading documents");
                }
            });
        }
        let current_document_id = window.hs_document_id;
        if (current_document_id) {
            section_container.find('.document-item[data-documentid=' + current_document_id + ']').addClass('active');
        }
    }
});


$(document).on('turbolinks:load', function () {
    if ($('.editor-section').length > 0) {
        $.get(window.location.href + '.js', {});
    }
});

function setIntervalWithTurbolinks(intervalFunction, milliseconds) {
    var interval = setInterval(intervalFunction, milliseconds);

    $(document).on('turbolinks:before-cache turbolinks:before-render', function () {
        clearTimeout(interval);
    });
}
window.setIntervalWithTurbolinks = setIntervalWithTurbolinks;


$(document).on('turbolinks:load', function () {
    if ($('#diffhtml').length > 0) {

        let oldHtml = document.getElementById('oldhtml');
        let newHtml = document.getElementById('newhtml');
        let diffHtml = document.getElementById('diffhtml');

        let output = htmldiff(oldHtml.innerHTML, newHtml.innerHTML);
        diffHtml.innerHTML = output;
    }
});

$(document).on('turbolinks:load', function () {
    $(".comment-show").on("click", function () {
        console.log('click');
        const target_id = $(this).data('targetcommentid');
        console.log(target_id);
        $('.comment-popup').removeClass('popup-box-on');
        $(target_id).addClass('popup-box-on');
    });
    $(".comment-hide").on("click", function () {
        $('.comment-popup').removeClass('popup-box-on');
    });

    $(".slide-panel-btn").on("click", function (e) {
        const target_panel = $($(this).data('target'));
        if (target_panel.hasClass('slide-panel-on')) {
            $('.slide-panel').removeClass('slide-panel-on');
            $('.slide-panel-btn').removeClass('active');
            $('.dropdown-menu').dropdown('hide');
        } else {
            $('.slide-panel').removeClass('slide-panel-on');
            $('.slide-panel-btn').removeClass('active');
            target_panel.addClass('slide-panel-on');
            $(this).addClass('active');
            $('.dropdown-menu').dropdown('hide');
        }
        e.stopPropagation()
    });
    $(".slide-panel-btn-close").on("click", function (e) {
        $('.slide-panel').removeClass('slide-panel-on');
        $('.slide-panel-btn').removeClass('active');
        $('.dropdown-menu').dropdown('hide');
        e.stopPropagation()
    });

    $("[data-trigger]").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var taskpanel_id = $(this).attr('data-trigger');
        $(taskpanel_id).toggleClass("show");
    });
    $(".btn-close").on("click", function (e) {
        $('.task-panel').removeClass("show");
    });

})

class addFields {
    // This executes when the function is instantiated.
    constructor() {
        this.links = document.querySelectorAll('.add_fields')
        this.iterateLinks()
    }

    iterateLinks() {
        // If there are no links on the page, stop the function from executing.
        if (this.links.length === 0) return
        // Loop over each link on the page. A page could have multiple nested forms.
        this.links.forEach(link => {
            link.addEventListener('click', e => {
                this.handleClick(link, e)
            })
        })
    }

    handleClick(link, e) {
        // Stop the function from executing if a link or event were not passed into the function.
        if (!link || !e) return
        // Prevent the browser from following the URL.
        e.preventDefault()
        // Save a unique timestamp to ensure the key of the associated array is unique.
        let time = new Date().getTime()
        // Save the data id attribute into a variable. This corresponds to `new_object.object_id`.
        let linkId = link.dataset.id
        // Create a new regular expression needed to find any instance of the `new_object.object_id` used in the fields data attribute if there's a value in `linkId`.
        let regexp = linkId ? new RegExp(linkId, 'g') : null
        // Replace all instances of the `new_object.object_id` with `time`, and save markup into a variable if there's a value in `regexp`.
        let newFields = regexp ? link.dataset.fields.replace(regexp, time) : null
        // Add the new markup to the form if there are fields to add.
        newFields ? link.insertAdjacentHTML('beforebegin', newFields) : null
    }
}

// Wait for turbolinks to load, otherwise `document.querySelectorAll()` won't work
window.addEventListener('turbolinks:load', () => new addFields())


Dropzone.autoDiscover = false;
Dropzone.Dropzone.autoDiscover = false;
$(document).on('turbolinks:load', function () {
    if ($(".misdropzone").length > 0) {
        // Dropzone.options.misdropzone = {
        // };
        new Dropzone.Dropzone(".misdropzone", {
            dictDefaultMessage: 'Drop files here or click to upload',
            maxFilesize: 10
        });
    }


    if ($(".filingcabmisdropzone").length > 0) {
        // Dropzone.options.misdropzone = {
        // };
        var dz = new Dropzone.Dropzone(".filingcabmisdropzone", {
            dictDefaultMessage: 'Drop files here or click to upload',
            maxFilesize: 10
        });
        dz.on("success", function (file) {
            $.get(window.location.pathname + '.js');
        });
    }

    if ($(".reloadmisdropzone").length > 0) {
        // Dropzone.options.misdropzone = {
        // };
        var dz = new Dropzone.Dropzone(".reloadmisdropzone", {
            dictDefaultMessage: 'Drop documents here or click to upload',
            maxFilesize: 10
        });
        dz.on("success", function (file) {
            $.get(window.location.pathname + '.js');
        });
    }

    if ($(".reloadmisdropzoneimageonly").length > 0) {
        // Dropzone.options.misdropzone = {
        // };
        var dzimage = new Dropzone.Dropzone(".reloadmisdropzoneimageonly", {
            dictDefaultMessage: 'Select photos',
            maxFilesize: 10,
            acceptedFiles: ".jpeg,.jpg,.png,.gif",
            capture: "camera"
        });
        dzimage.on("success", function (file) {
            $.get(window.location.pathname + '.js');
        });
    }
});



$.fn.textWidth = function (text, font) {
    if (!$.fn.textWidth.fakeEl) $.fn.textWidth.fakeEl = $('<span>').hide().appendTo(document.body);
    $.fn.textWidth.fakeEl.text(text || this.val() || this.text()).css('font', font || this.css('font'));
    return $.fn.textWidth.fakeEl.width();
};

function inline_text_box_width_adjust(element) {
    var padding = 60; // Works as a minimum width
    var valWidth = ($(element).textWidth() + padding) + 'px';
    $('#' + element.id + '-width').html(valWidth);
    $('.document-title-field ').css('width', valWidth);
}

// Expandable text input
$(document).on('turbolinks:load', function () {
    $('.document-title-field ').on('input', function () {
        inline_text_box_width_adjust(this);
    }).trigger('input');
    inline_text_box_width_adjust('.document-title-field');
});


$(document).on('turbolinks:load', function () {
    if (window.calendarEventsUrl) {
        var calendarEl = document.getElementById('calendar');
        let calendar = new Calendar(calendarEl, {
            plugins: [dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin],
            editable: true,
            initialView: 'dayGridMonth',
            locale: 'en-gb',
            titleFormat: {
                month: '2-digit',
                year: 'numeric',
                day: 'numeric',
            },
            headerToolbar: {
                left: 'prev,next today',
                center: 'title',
                right: 'dayGridMonth listWeek'
            },
            buttonText: {
                today: 'Today',
                month: 'Month View',
                list: 'List View'
            },
            eventSources: [
                {
                    url: window.calendarEventsUrl,
                    color: 'yellow',
                    textColor: 'black'
                }
            ],
            eventTimeFormat: {
                hour: 'numeric',
                minute: 'numeric',
                meridiem: 'short',
                omitZeroMinute: true
            },
            eventDidMount: function(info) {
                $(info.el).tooltip({
                    title: info.event.title,
                });
              },
            dateClick: function (info) {
                $.get(window.newEventsUrl + '?scheduled_at=' + info.dateStr);
            },
            eventClick: function (info) {
                info.jsEvent.preventDefault();
                $.get(info.event.url + '.js');
            },
            eventDrop: function (info) {
                $.ajax({
                    url: info.event.url + '.js',
                    type: 'PUT',
                    data: {
                        scheduled_report: {
                            scheduled_at: info.event.start
                        }
                    },
                });
                // $.put(info.event.url + '?scheduled_at_date=' + info.dateStr);
            },
            noEventsContent: 'No checklists scheduled',
        });
        calendar.render();
        window.calendar = calendar;
    }
});

$(document).on('turbolinks:load', function () {
  $('.copy-button').on('click', function(e) {
    e.preventDefault();
    var copyInput = document.getElementById('copy-input').value;
    navigator.clipboard.writeText(copyInput);
    $(this).tooltip({
        title: 'Copied to clipboard!',
        placement: 'bottom',
        trigger: 'manual'
    }).tooltip('show');
    setTimeout(function() {
        $(this).tooltip('hide');
    }
    .bind(this), 1500);
  });
});

$(".single-daterange").daterangepicker({
    parentEl: "#newLeaveEventModal .modal-body"
});

$(document).on('turbolinks:load', function () {
    $('.form-datepicker').daterangepicker({
        autoApply: true,
        autoUpdateInput: false,
        singleDatePicker: true,
        showDropdowns: true,
        locale: {
            format: 'DD/MM/YYYY',
            firstDay: 1,
        },
    })

    $('.form-datepicker').on('apply.daterangepicker', function(ev, picker) {
        $(this).val(picker.startDate.format('DD/MM/YYYY'));
    });

    $('[data-datepicker]').each(function() {
        var options = {
            autoApply: true,
            autoUpdateInput: false,
            singleDatePicker: true,
            showDropdowns: true,
            locale: {
                format: 'DD/MM/YYYY',
                firstDay: 1,
            },
        };

        var additionalOptions = $(this).data("datepicker") || {};
        jQuery.extend(options, additionalOptions);

        // Year dropdown is driven by minYear/maxYear; coerce date bounds so both stay in sync
        if (options.minDate) {
            options.minDate = moment(options.minDate);
            if (options.minYear == null) options.minYear = options.minDate.year();
        }
        if (options.maxDate) {
            options.maxDate = moment(options.maxDate);
            if (options.maxYear == null) options.maxYear = options.maxDate.year();
        }

        $(this).daterangepicker(options);
    });

    $('[data-datepicker]').on('apply.daterangepicker', function(ev, picker) {
        $(this).val(picker.startDate.format('DD/MM/YYYY'));
    });

    $('.app-datepicker').each(function() {
        const $el = $(this);
        // Fields with custom time-based behavior are initialized separately below
        if ($el.hasClass('past-only')) return;
        if ($el.hasClass('single-daterange-with-time')) return;
        if ($el.data('daterangepicker')) return;

        const isLeaveStartEnd = $el.hasClass('start-date') || $el.hasClass('end-date');
        const leaveMinDate = moment().subtract(5, 'years');
        const leaveMaxDate = moment().add(5, 'years');

        $el.daterangepicker({
            autoApply: true,
            autoUpdateInput: false,
            singleDatePicker: true,
            // Leave start/end fields should show day/month/year dropdowns
            showDropdowns: $el.hasClass('start-date') || $el.hasClass('end-date'),
            // Keep leave dates within a reasonable window
            minDate: isLeaveStartEnd ? leaveMinDate : undefined,
            maxDate: isLeaveStartEnd ? leaveMaxDate : undefined,
            locale: {
                format: 'DD/MM/YYYY',
                firstDay: 1,
            },
        });
    })

    $('.app-datepicker:not(.past-only):not(.single-daterange-with-time)').on('apply.daterangepicker', function(ev, picker) {
        $(this).val(picker.startDate.format('DD/MM/YYYY'));
    });

    const defaultDob = moment('01/01/1990', 'DD/MM/YYYY');

    $('.date-of-birth').daterangepicker({
        autoApply: true,
        autoUpdateInput: false,
        singleDatePicker: true,
        showDropdowns: true,
        maxDate: moment(),
        minDate: moment('01/01/1940', 'DD/MM/YYYY'),
        startDate: defaultDob,
        locale: {
            format: 'DD/MM/YYYY',
            firstDay: 1,
        },
    });

    $('.date-of-birth').on('apply.daterangepicker', function(ev, picker) {
        $(this).val(picker.startDate.format('DD/MM/YYYY'));
    });

    
    $('.past-only').each(function() {
        const $el = $(this);
        if ($el.data('daterangepicker')) return;

        $el.daterangepicker({
            autoApply: true,
            autoUpdateInput: false,
            singleDatePicker: true,
            timePicker: true,
            timePicker24Hour: true,
            showDropdowns: true,
            minDate: moment('01/01/2020', 'DD/MM/YYYY'),
            maxDate: moment(),
            minYear: 2020,
            maxYear: moment().year(),
            locale: {
                format: 'DD/MM/YYYY HH:mm',
                firstDay: 1,
            },
        });
    });

    $('.past-only').on('apply.daterangepicker', function(ev, picker) {
        $(this).val(picker.startDate.format('DD/MM/YYYY HH:mm'));
    });

});

$(document).on('turbolinks:load', function () {
    if ($("#return_to_work_absence_start, #return_to_work_return_date, #absence_length").length === 3) {
        let absenceStart = $('#return_to_work_absence_start')[0].value
        let absenceEnd = $('#return_to_work_return_date')[0].value

        function calcAbsenceLength() {
            if (absenceStart && absenceEnd) {
                const momentStart = moment(absenceStart, 'DD/MM/YYYY')
                const momentEnd = moment(absenceEnd, 'DD/MM/YYYY')
                $("#absence_length")[0].innerHTML = moment.preciseDiff(momentStart, momentEnd)
            }
        }

        calcAbsenceLength();

        $('#return_to_work_absence_start').on('apply.daterangepicker', function(ev, picker) {
            absenceStart = picker.startDate.format('DD/MM/YYYY');
            calcAbsenceLength();
        });

        $('#return_to_work_return_date').on('apply.daterangepicker', function(ev, picker) {
            absenceEnd = picker.startDate.format('DD/MM/YYYY');
            calcAbsenceLength();
        });
    }
});

// Code for showing/hiding custom meeting title text field for appraisals
$(document).on('turbolinks:load', function () {
    if ($("#custom-meeting-title-form-group")) {
        changeCustomMeetingTitle();
    }

    $('#meeting-title-select').on('change', function () {
        changeCustomMeetingTitle();
    });

    function changeCustomMeetingTitle() {
        let meetingTitleSelect = $('#meeting-title-select');
        let customMeetingTitle = $('#custom-meeting-title');
        let customMeetingTitleFormGroup = $('#custom-meeting-title-form-group');

        if (meetingTitleSelect.val() === "other") {
            customMeetingTitleFormGroup.show();
        } else {
            customMeetingTitleFormGroup.hide();
            customMeetingTitle.val("")
        }
    }
});

$(document).on('turbolinks:load', function () {
    $('#uk-employment-documentation-button').on('click', function () {
        $('#hr-document-select').val('uk_employment_documentation')
    });

    $("#new-custom-field-btn").on("click", function() {
        const activeTab = $(".nav-tabs .active").data("report");
        const link = $(this).attr("href");
        $(this).attr("href", link + "?previous_tab=" + activeTab);
    });
});

// Code for showing/hiding custom document label text field for a hr document
$(document).on('turbolinks:load', function () {
    if ($("#other-document-label-form-group")) {
        changeOtherDocumentLabel();
    }

    $('#hr_document-select').on('change', function () {
        changeOtherDocumentLabel();
    });

    function changeOtherDocumentLabel() {
        let hrDocumentSelect = $('#hr_document-select');
        let otherDocumentLabel = $('#other-document-label');
        let otherDocumentLabelFormGroup = $('#other-document-label-form-group');

        if (hrDocumentSelect.val() === "other") {
            otherDocumentLabelFormGroup.show();
        } else {
            otherDocumentLabelFormGroup.hide();
            otherDocumentLabel.val("")
        }
    }
});
// Hides form for release batch based on selected option
$(document).on('turbolinks:load', function () {
    if ($('#release-batch-select').length > 0) {
        changeReleaseBatchFields();
    }

    $('#release-batch-select').on('change', function () {
        changeReleaseBatchFields();
    });

    function changeReleaseBatchFields() {
        if ($('#release-batch-select').val() == '') {
            $('#fields-for-release-batch').show();
        } else {
            $('#fields-for-release-batch').hide();
            $('#release-batch-name-field').val('');
        }
    }
});

let selectedDocs = new Set();

$(document).on('turbolinks:load', function () {
  const $modal = $('#shareFilesModal');
  const tableSelector = '.dt-simple';
  const table = $modal.find(tableSelector).DataTable();

  $modal.on('change', '.hs-doc-checkbox', function () {
    const docId = parseInt($(this).val());
    if ($(this).is(':checked')) {
      selectedDocs.add(docId);
    } else {
      selectedDocs.delete(docId);
    }
  });

  table.on('draw', function () {
    $modal.find('.hs-doc-checkbox').each(function () {
      const docId = parseInt($(this).val());
      $(this).prop('checked', selectedDocs.has(docId));
    });
  });

  $modal.find('form').on('submit', function () {
    $(this).find('input[name="hs_document_ids[]"]').remove();

    selectedDocs.forEach(docId => {
      $(this).append(
        $('<input>').attr({
          type: 'hidden',
          name: 'hs_document_ids[]',
          value: docId
        })
      );
    });
  });

  $modal.on('hidden.bs.modal', function () {
    selectedDocs.clear();
  });
});
